import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { IApiParams } from '../../interface/IApiParams';
import { getApiVersion } from '../../utils/utils';
import { getApi } from '../getApi';

export const apiGetDevices = async (state: string, search?: string) => {
  const apiVersion = getApiVersion();
  const params: IApiParams = {
    url:
      search === undefined
        ? `/device/getDevices${apiVersion}.php?state=${state}`
        : `/device/getDevices${apiVersion}.php?state=${state}&search=${search}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'GET');
};
